// @flow
// React Libs
import React from 'react';
// Components
import Tooltip from '../../../../../Resources/Common/Tooltip';
import SimpleDocumentComponent from '../../../Documents/SimpleDocumentComponent';

type Props = {
  hasRights: boolean,
  blocked: boolean,
  proposalUid: string
};

export default function ArticlesOfIncorporation({
  hasRights,
  blocked,
  proposalUid
}: Props) {
  return (
    <SimpleDocumentComponent
      title="Statuts de pré-levée"
      tooltip={Tooltip.DocumentProjectFinancialBp.document}
      hasRights={hasRights}
      blocked={blocked}
      proposalUid={proposalUid}
    />
  );
}
